"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalType = void 0;
var PortalType;
(function (PortalType) {
    PortalType["MASTERS"] = "master";
    PortalType["BACHELORS"] = "bachelor";
    PortalType["PHD"] = "phd";
    PortalType["SHORT_COURSES"] = "short";
    PortalType["DISTANCE_LEARNING"] = "distance_learning";
    PortalType["PREPARATION_COURSES"] = "preparation_courses";
})(PortalType = exports.PortalType || (exports.PortalType = {}));
